<template>
  <div class="footer">
    <div class="left"></div>
    <div class="box">
      <img src="~@/assets/img/sf_logo.png" width="170" />
    </div>
    <div class="right">Copyright © 2021,2022, Hitachi Solutions, Ltd.</div>
  </div>
</template>

<style lang="scss" scoped>
.footer {
  background: transparent;
  font-size: small;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-end;

  .box {
    justify-self: center;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    &::before {
      content: "運営会社";
      position: absolute;
      display: inline;
      line-height: 1rem;
      left: -5rem;
    }
  }
  .left {
    justify-self: flex-start;
  }
  .right {
    justify-self: flex-end;
  }
}
</style>
